import WhatsAppIcon from '../../components/WhatsAppIcon';

const WA_URL =
  "https://wa.me/5511986304696?text=Ol%C3%A1!%20Vim%20pelo%20site%20da%20l'ora%20e%20gostaria%20de%20uma%20proposta.";

export default function Cta() {
  return (
    <section className="cta" id="contato">
      <div className="wrap">
        <div>
          <h2>
            Vamos dar forma<br />
            à sua <em>próxima ideia?</em>
          </h2>
          <p>Conte o que você precisa. A proposta começa por aí.</p>
        </div>
        <div className="contact-actions">
          <a className="btn light" href={WA_URL} target="_blank" rel="noopener noreferrer">
            <WhatsAppIcon />
            <span>
              Falar com a l’ora<span className="arrow" aria-hidden="true">→</span>
            </span>
          </a>
          <a href="https://wa.me/5511986304696" target="_blank" rel="noopener noreferrer">
            <WhatsAppIcon />
            <span>(11) 98630-4696</span>
          </a>
        </div>
      </div>
    </section>
  );
}
